import React, { useState } from 'react';

const AdminLogin = ({ onLogin, error }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    onLogin(email, password);
  };

  return (
    <div className="admin-login-shell">
      <div className="admin-login-card glass-card">
        <span className="section__label">Admin Access</span>
        <h2>Sign in to the admin panel</h2>
        <p className="admin-login-hint">Use the hardcoded admin credentials to access editing.</p>

        <form className="admin-login-form" onSubmit={handleSubmit}>
          <div className="admin-field">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="Enter admin email"
              autoComplete="username"
              required
            />
          </div>

          <div className="admin-field">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter password"
              autoComplete="current-password"
              required
            />
          </div>

          {error && <div className="admin-message admin-login-error">{error}</div>}

          <button type="submit" className="button button--primary admin-login-submit">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;